<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <dark-Toggler class="d-none d-lg-block" />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <!-- Botón de Avisos (campana) -->
      <b-nav-item class="mr-1">
        <b-dropdown
          variant="outline-secondary"
          size="sm"
          no-caret
          right
          class="dropdown-avisos"
          @show="cargarMisAvisos"
        >
          <template #button-content>
            <i class="fa-solid fa-bell"></i>
            <b-badge
              v-if="avisosNoLeidos > 0"
              variant="danger"
              pill
              class="badge-tasks"
            >
              {{ avisosNoLeidos > 99 ? '99+' : avisosNoLeidos }}
            </b-badge>
          </template>

          <b-dropdown-header>Avisos</b-dropdown-header>
          <b-dropdown-text v-if="misAvisos.length === 0">
            No tienes avisos pendientes
          </b-dropdown-text>
          <b-dropdown-item
            v-for="aviso in misAvisos.slice(0, 5)"
            :key="aviso.id"
            @click="marcarLeidoAviso(aviso.id)"
          >
            <div class="d-flex align-items-start">
              <b-badge :variant="variantePrioridadAviso(aviso.prioridad)" class="mr-50 mt-25" pill>&nbsp;</b-badge>
              <div>
                <strong>{{ aviso.titulo }}</strong>
                <p class="mb-0 text-muted small text-truncate" style="max-width: 250px;">{{ aviso.mensaje }}</p>
              </div>
            </div>
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item v-if="misAvisos.length > 0" @click="marcarTodosLeidosAvisos">
            <i class="fa-solid fa-check-double mr-50"></i> Marcar todos como leidos
          </b-dropdown-item>
          <b-dropdown-item @click="verTodosAvisos">
            <i class="fa-solid fa-list mr-50"></i> Ver todos los avisos
          </b-dropdown-item>
        </b-dropdown>
      </b-nav-item>

      <!-- Botón de Tareas -->
      <b-nav-item class="mr-1">
        <b-button
          variant="outline-secondary"
          size="sm"
          @click="mostrarTareas = true"
          v-b-tooltip.hover
          :title="tareasVencidas > 0 ? `${tareasVencidas} vencidas` : 'Tareas'"
        >
          <i class="fa-solid fa-list-check"></i>
          <!-- Badge vencidas (rojo) -->
          <b-badge
            v-if="tareasVencidas > 0"
            variant="danger"
            pill
            class="badge-tasks"
          >
            {{ tareasVencidas > 99 ? '99+' : tareasVencidas }}
          </b-badge>
          <!-- Badge pendientes (azul) si no hay vencidas -->
          <b-badge
            v-else-if="tareasPendientes > 0"
            variant="primary"
            pill
            class="badge-tasks"
          >
            {{ tareasPendientes > 99 ? '99+' : tareasPendientes }}
          </b-badge>
        </b-button>
      </b-nav-item>

      <!-- Botón de Solicitudes de Vacaciones pendientes (solo admin, solo si hay pendientes) -->
      <b-nav-item class="mr-1" v-if="esAdmin && solicitudesPendientes > 0">
        <b-button
          variant="outline-secondary"
          size="sm"
          @click="$router.push({ name: 'vacaciones-admin', query: { tab: 'solicitudes' } })"
          v-b-tooltip.hover
          :title="solicitudesPendientes > 0 ? `${solicitudesPendientes} solicitudes pendientes` : 'Solicitudes de vacaciones'"
        >
          <i class="fa-solid fa-umbrella-beach"></i>
          <b-badge
            v-if="solicitudesPendientes > 0"
            variant="warning"
            pill
            class="badge-tasks"
          >
            {{ solicitudesPendientes > 99 ? '99+' : solicitudesPendientes }}
          </b-badge>
        </b-button>
      </b-nav-item>

      <!-- Botón de Fichaje (solo si tiene llave) -->
      <b-nav-item class="mr-1" v-if="userData && userData.llave">
        <b-button
          :variant="fichado ? 'success' : 'outline-secondary'"
          size="sm"
          @click="toggleFichaje"
          :disabled="loadingFichaje"
          v-b-tooltip.hover
          :title="fichado ? 'Clock Out - Entrada: ' + horaEntradaFormateada : 'Clock In'"
        >
          <i v-if="loadingFichaje" class="fa-solid fa-spinner fa-spin"></i>
          <i v-else :class="['fa-solid fa-clock', fichado ? '' : 'text-muted']"></i>
          <span class="d-none d-md-inline ml-1">{{ fichado ? 'Fichado' : 'Fichar' }}</span>
        </b-button>
      </b-nav-item>
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{userData.nombre}}
            </p>
            <span class="user-status">Admin</span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="require('@/assets/images/avatars/13-small.png')"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <!--<b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>Profile</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="MailIcon"
            class="mr-50"
          />
          <span>Inbox</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="CheckSquareIcon"
            class="mr-50"
          />
          <span>Task</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="MessageSquareIcon"
            class="mr-50"
          />
          <span>Chat</span>
        </b-dropdown-item>

        <b-dropdown-divider />-->

        <b-dropdown-item link-class="d-flex align-items-center" @click="abrirModal2fa">
          <feather-icon
            size="16"
            icon="ShieldIcon"
            class="mr-50"
          />
          <span>Verificación en dos pasos</span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>

    <!-- Modal 2FA (TOTP) -->
    <b-modal id="modal-2fa" title="Verificación en dos pasos" hide-footer centered>
      <div v-if="dosFa.cargando" class="text-center py-2">Cargando...</div>

      <!-- Activado: solo se puede desactivar con un código válido -->
      <b-form v-else-if="dosFa.activo" @submit.prevent="guardar2fa(false)">
        <p class="text-success mb-1"><i class="fa-solid fa-shield-halved mr-50"></i>La verificación en dos pasos está <strong>activada</strong>.</p>
        <b-form-group label="Introduce un código de tu app para desactivarla">
          <b-form-input v-model="dosFa.codigo" inputmode="numeric" maxlength="6" placeholder="123456" required autocomplete="one-time-code" />
        </b-form-group>
        <b-button type="submit" variant="outline-danger" block :disabled="dosFa.guardando">Desactivar</b-button>
      </b-form>

      <!-- Desactivado: generar QR -> escanear -> confirmar con código -->
      <div v-else>
        <p class="text-muted">Añade una capa extra de seguridad: al iniciar sesión se pedirá un código de 6 dígitos de una app como Google Authenticator, Authy o 1Password.</p>
        <b-button v-if="!dosFa.otpauth" variant="primary" block :disabled="dosFa.guardando" @click="generarQr2fa">Empezar: generar código QR</b-button>
        <b-form v-else @submit.prevent="guardar2fa(true)">
          <div class="text-center mb-1">
            <canvas ref="qr2fa"></canvas>
            <small class="text-muted d-block">Escanea el QR con tu app. Si no puedes, introduce esta clave a mano:</small>
            <code class="user-select-all">{{ dosFa.secreto }}</code>
          </div>
          <b-form-group label="Código que muestra la app">
            <b-form-input v-model="dosFa.codigo" inputmode="numeric" maxlength="6" placeholder="123456" required autocomplete="one-time-code" />
          </b-form-group>
          <b-button type="submit" variant="success" block :disabled="dosFa.guardando">Activar</b-button>
        </b-form>
      </div>
    </b-modal>

    <!-- Modal Confirmar Fichaje -->
    <b-modal
      id="modal-confirmar-fichaje"
      :title="fichado ? 'Terminar Jornada' : 'Iniciar Jornada'"
      @ok="confirmarFichaje"
      :ok-title="fichado ? 'Clock Out' : 'Clock In'"
      :ok-variant="fichado ? 'danger' : 'success'"
      cancel-title="Cancelar"
    >
      <div class="text-center mb-3">
        <i :class="['fa-solid', fichado ? 'fa-right-from-bracket text-danger' : 'fa-right-to-bracket text-success']" style="font-size: 3rem"></i>
      </div>
      <p class="text-center" v-if="!fichado">
        ¿Deseas iniciar tu jornada laboral?
      </p>
      <p class="text-center" v-else>
        ¿Deseas terminar tu jornada laboral?
      </p>
      <p class="text-center text-muted small" v-if="fichado && horaEntrada">
        Entrada: {{ horaEntradaFormateada }}
      </p>
    </b-modal>

    <!-- Sidebar de Tareas -->
    <TareasSidebar
      :visible="mostrarTareas"
      @close="mostrarTareas = false"
      @actualizado="cargarTareasPendientes"
    />

    <!-- Modal Avisos al entrar -->
    <b-modal
      v-model="mostrarModalAvisos"
      title="Tienes avisos nuevos"
      ok-title="Marcar todos como leidos"
      ok-variant="primary"
      cancel-title="Cerrar"
      @ok.prevent="marcarTodosLeidosAvisos"
      size="lg"
      scrollable
    >
      <div v-for="aviso in misAvisos" :key="aviso.id" class="mb-3 p-2 border rounded">
        <div class="d-flex justify-content-between align-items-start">
          <div>
            <h6 class="mb-25">
              <b-badge :variant="variantePrioridadAviso(aviso.prioridad)" class="mr-50">{{ aviso.prioridad }}</b-badge>
              {{ aviso.titulo }}
            </h6>
            <p class="mb-25">{{ aviso.mensaje }}</p>
            <small class="text-muted">{{ formatFechaAviso(aviso.created_at) }}</small>
          </div>
          <b-button variant="flat-success" size="sm" @click="marcarLeidoAviso(aviso.id)" v-b-tooltip.hover title="Marcar como leido">
            <i class="fa-solid fa-check"></i>
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- Modal Todos los Avisos -->
    <b-modal
      v-model="mostrarModalTodosAvisos"
      title="Todos mis avisos"
      ok-only
      ok-title="Cerrar"
      size="lg"
      scrollable
    >
      <div v-if="loadingTodosAvisos" class="text-center my-2">
        <b-spinner small></b-spinner>
      </div>
      <div v-else-if="todosAvisos.length === 0" class="text-center text-muted my-2">
        No tienes avisos
      </div>
      <div v-for="aviso in todosAvisos" :key="'todos-' + aviso.id" class="mb-2 p-2 border rounded" :class="{ 'bg-light': aviso.leido }">
        <div class="d-flex justify-content-between align-items-start">
          <div>
            <h6 class="mb-25">
              <b-badge :variant="variantePrioridadAviso(aviso.prioridad)" class="mr-50">{{ aviso.prioridad }}</b-badge>
              {{ aviso.titulo }}
              <b-badge v-if="!aviso.leido" variant="primary" pill class="ml-50">Nuevo</b-badge>
            </h6>
            <p class="mb-25">{{ aviso.mensaje }}</p>
            <small class="text-muted">{{ formatFechaAviso(aviso.created_at) }}</small>
            <small v-if="aviso.leido" class="text-muted ml-1">| Leido: {{ formatFechaAviso(aviso.leido_at) }}</small>
          </div>
          <b-button v-if="!aviso.leido" variant="flat-success" size="sm" @click="marcarLeidoAvisoTodos(aviso.id)" v-b-tooltip.hover title="Marcar como leido">
            <i class="fa-solid fa-check"></i>
          </b-button>
          <i v-else class="fa-solid fa-check-double text-success mt-50"></i>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdown, BDropdownItem, BDropdownDivider, BDropdownHeader, BDropdownText, BAvatar, BNavItem, BButton, VBTooltip, BModal, BBadge, BForm, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import QRCode from 'qrcode'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import TareasSidebar from './TareasSidebar.vue'
import useJwt from '@/auth/jwt/useJwt'
import { initialAbility } from '@/libs/acl/config'
import { CloudLightningIcon } from 'vue-feather-icons'
import axios from '@axios'
import { EventBus } from '@/libs/eventBus'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BDropdownHeader,
    BDropdownText,
    BAvatar,
    BNavItem,
    BButton,
    BModal,
    BBadge,
    BForm,
    BFormGroup,
    BFormInput,
    TareasSidebar,

    // Navbar Components
    DarkToggler,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      fichado: false,
      horaEntrada: null,
      loadingFichaje: false,
      mostrarTareas: false,
      tareasPendientes: 0,
      tareasVencidas: 0,
      solicitudesPendientes: 0,
      avisosNoLeidos: 0,
      misAvisos: [],
      mostrarModalAvisos: false,
      todosAvisos: [],
      mostrarModalTodosAvisos: false,
      loadingTodosAvisos: false,
      dosFa: { cargando: false, guardando: false, activo: false, secreto: '', otpauth: '', codigo: '' },
    }
  },
  computed: {
    esAdmin() {
      const permisos = JSON.parse(localStorage.getItem('permisos') || '{}')
      const parsed = typeof permisos === 'string' ? JSON.parse(permisos) : permisos
      if (!parsed || Object.keys(parsed).length === 0) return true
      return parsed['vacaciones-admin'] === true
    },
    horaEntradaFormateada() {
      if (!this.horaEntrada) return ''
      return new Date(this.horaEntrada).toLocaleTimeString('es-ES', {
        hour: '2-digit',
        minute: '2-digit'
      })
    }
  },
   methods: {
    logout() {
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
      localStorage.removeItem('userData')
      this.$router.push({ name: 'auth-login' })
    },
    // ─── 2FA ───
    toast2fa(msg, variant) {
      this.$bvToast.toast(msg, { title: variant === 'danger' ? 'Error' : 'Verificación en dos pasos', variant, solid: true })
    },
    async abrirModal2fa() {
      this.dosFa = { cargando: true, guardando: false, activo: false, secreto: '', otpauth: '', codigo: '' }
      this.$bvModal.show('modal-2fa')
      try {
        const { data } = await axios.get('/usuarios/2fa')
        this.dosFa.activo = !!data.activo
      } catch (e) {
        console.error(e)
        this.toast2fa('No se pudo consultar el estado del 2FA', 'danger')
      } finally {
        this.dosFa.cargando = false
      }
    },
    async generarQr2fa() {
      this.dosFa.guardando = true
      try {
        const { data } = await axios.post('/usuarios/2fa/setup')
        this.dosFa.secreto = data.secreto
        this.dosFa.otpauth = data.otpauth
        await this.$nextTick()
        await QRCode.toCanvas(this.$refs.qr2fa, data.otpauth, { width: 200, margin: 1 })
      } catch (e) {
        console.error(e)
        this.toast2fa((e.response && e.response.data && e.response.data.msg) || 'No se pudo generar el código QR', 'danger')
      } finally {
        this.dosFa.guardando = false
      }
    },
    async guardar2fa(activo) {
      this.dosFa.guardando = true
      try {
        const { data } = await axios.put('/usuarios/2fa', { activo, codigo: this.dosFa.codigo })
        this.toast2fa(data.msg, 'success')
        this.$bvModal.hide('modal-2fa')
      } catch (e) {
        console.error(e)
        this.dosFa.codigo = ''
        this.toast2fa((e.response && e.response.data && e.response.data.msg) || 'Error al guardar', 'danger')
      } finally {
        this.dosFa.guardando = false
      }
    },
    async cargarEstadoFichaje() {
      try {
        const response = await axios.get('/fichajes/estado')
        this.fichado = response.data.fichado
        this.horaEntrada = response.data.hora_entrada
      } catch (error) {
        console.error('Error al cargar estado fichaje:', error)
      }
    },
    toggleFichaje() {
      this.$bvModal.show('modal-confirmar-fichaje')
    },

    async confirmarFichaje() {
      this.loadingFichaje = true
      try {
        if (this.fichado) {
          await axios.post('/fichajes/salida')
          this.fichado = false
          this.horaEntrada = null
          this.$bvToast.toast('Clock Out registrado', {
            title: 'Fichaje',
            variant: 'success',
            solid: true,
          })
          EventBus.$emit('fichaje-actualizado')
        } else {
          const response = await axios.post('/fichajes/entrada')
          this.fichado = true
          this.horaEntrada = response.data.hora_entrada
          this.$bvToast.toast('Clock In registrado', {
            title: 'Fichaje',
            variant: 'success',
            solid: true,
          })
          EventBus.$emit('fichaje-actualizado')
        }
      } catch (error) {
        console.error('Error en fichaje:', error)
        this.$bvToast.toast(error.response?.data?.message || 'Error al fichar', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.loadingFichaje = false
      }
    },

    async cargarTareasPendientes() {
      try {
        const response = await axios.get('/tareas/resumen')
        this.tareasPendientes = response.data.pendientes || 0
        this.tareasVencidas = response.data.vencidas || 0
      } catch (error) {
        console.error('Error al cargar tareas pendientes:', error)
      }
    },

    async cargarSolicitudesPendientes() {
      if (!this.esAdmin) return
      try {
        const response = await axios.get('/vacaciones/admin/pendientes')
        this.solicitudesPendientes = (response.data && response.data.length) || 0
      } catch (error) {
        console.error('Error al cargar solicitudes pendientes:', error)
      }
    },

    async cargarResumenAvisos() {
      try {
        const response = await axios.get('/avisos/resumen')
        this.avisosNoLeidos = response.data.no_leidos || 0
        if (this.avisosNoLeidos > 0) {
          await this.cargarMisAvisos()
          this.mostrarModalAvisos = true
        }
      } catch (error) {
        console.error('Error al cargar resumen avisos:', error)
      }
    },

    async cargarMisAvisos() {
      try {
        const response = await axios.get('/avisos/mis-avisos')
        this.misAvisos = response.data
        this.avisosNoLeidos = this.misAvisos.length
      } catch (error) {
        console.error('Error al cargar mis avisos:', error)
      }
    },

    async marcarLeidoAviso(id) {
      try {
        await axios.put(`/avisos/${id}/leido`)
        this.misAvisos = this.misAvisos.filter(a => a.id !== id)
        this.avisosNoLeidos = this.misAvisos.length
        if (this.misAvisos.length === 0) {
          this.mostrarModalAvisos = false
        }
      } catch (error) {
        console.error('Error al marcar aviso como leido:', error)
      }
    },

    async marcarTodosLeidosAvisos() {
      try {
        await axios.put('/avisos/marcar-todos')
        this.misAvisos = []
        this.avisosNoLeidos = 0
        this.mostrarModalAvisos = false
      } catch (error) {
        console.error('Error al marcar todos los avisos:', error)
      }
    },

    async verTodosAvisos() {
      this.mostrarModalTodosAvisos = true
      this.loadingTodosAvisos = true
      try {
        const response = await axios.get('/avisos/mis-avisos/todos')
        this.todosAvisos = response.data
      } catch (error) {
        console.error('Error al cargar todos los avisos:', error)
      } finally {
        this.loadingTodosAvisos = false
      }
    },

    async marcarLeidoAvisoTodos(id) {
      try {
        await axios.put(`/avisos/${id}/leido`)
        const aviso = this.todosAvisos.find(a => a.id === id)
        if (aviso) {
          aviso.leido = 1
          aviso.leido_at = new Date().toISOString()
        }
        this.misAvisos = this.misAvisos.filter(a => a.id !== id)
        this.avisosNoLeidos = this.misAvisos.length
      } catch (error) {
        console.error('Error al marcar aviso como leido:', error)
      }
    },

    variantePrioridadAviso(prioridad) {
      const map = { info: 'info', importante: 'warning', urgente: 'danger' }
      return map[prioridad] || 'secondary'
    },

    formatFechaAviso(fecha) {
      if (!fecha) return ''
      return new Date(fecha).toLocaleDateString('es-ES', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit'
      })
    },
  },
  mounted() {
    this.cargarEstadoFichaje()
    this.cargarTareasPendientes()
    this.cargarSolicitudesPendientes()
    this.cargarResumenAvisos()
    EventBus.$on('fichaje-actualizado', this.cargarEstadoFichaje)
  },
  beforeDestroy() {
    EventBus.$off('fichaje-actualizado', this.cargarEstadoFichaje)
  }
}
</script>

<style scoped>
.badge-tasks {
  position: absolute;
  top: -5px;
  right: -5px;
  font-size: 0.65rem;
  min-width: 18px;
  height: 18px;
  /* Centrado con flex: el line-height lo pisan los estilos .badge del tema */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  padding: 0 4px;
}

.b-nav-item .btn {
  position: relative;
}
</style>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500;600;700&display=swap');

// ══════════════════════════════════════════════════════════════
// HARBER ERP — TOP NAVBAR + HORIZONTAL MENU
// Same tokens as /pedido-taller-vero/fabricando
// Global overrides (non-scoped)
// ══════════════════════════════════════════════════════════════

$h-bg:        #F8FAFC;
$h-surface:   #FFFFFF;
$h-surface-2: #F1F5F9;
$h-border:    #E2E8F0;
$h-divider:   #EEF2F7;
$h-ink:       #1E293B;
$h-mute:      #64748B;
$h-soft:      #94A3B8;
$h-primary:   #3B82F6;
$h-primary-soft: #60A5FA;
$h-cta:       #F97316;
$h-emerald:   #10B981;
$h-coral:     #EF4444;

// ────────────────────────────────────
// 1. APP CONTENT BG
// ────────────────────────────────────
.horizontal-layout .app-content,
.horizontal-layout .content-wrapper,
.horizontal-layout body,
body.horizontal-layout {
  background: $h-bg !important;
}

// Dark: mismo fondo que $theme-dark-body-bg
.dark-layout .horizontal-layout .app-content,
.dark-layout .horizontal-layout .content-wrapper,
body.dark-layout.horizontal-layout {
  background: #1a1a1a !important;
}

// ────────────────────────────────────
// 2. TOP HEADER BAR (with brand, dark toggle, bell, fichaje, user)
// ────────────────────────────────────
.horizontal-layout .header-navbar.navbar-horizontal {
  background: $h-surface !important;
  border-bottom: 1px solid $h-border !important;
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.04) !important;
  backdrop-filter: none !important;
  font-family: 'Plus Jakarta Sans', sans-serif !important;
  height: 64px;

  .navbar-container {
    background: transparent !important;
    box-shadow: none !important;
    padding: 0 28px;
    height: 64px;
    border-radius: 0;
  }
}

// Brand (HarbERP logo + text)
.navbar-brand {
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center;
  gap: 10px;

  .brand-logo {
    display: inline-flex;
    align-items: center;
    justify-content: center;

    img {
      width: 28px;
      height: 28px;
      object-fit: contain;
    }
  }

  .brand-text {
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-size: 17px !important;
    font-weight: 800 !important;
    color: $h-ink !important;
    letter-spacing: -0.02em;
    margin: 0 !important;
    line-height: 1;
  }
}

// Dark mode toggle
.horizontal-layout .navbar-container .dark-toggler {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: $h-surface-2;
  border: 1px solid $h-border;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: $h-mute;
  transition: all 200ms ease;
  cursor: pointer;

  &:hover {
    background: rgba(59, 130, 246, 0.08);
    color: $h-primary;
    border-color: $h-primary-soft;
  }

  svg { width: 16px; height: 16px; }
}

// ────────────────────────────────────
// 3. NAVBAR ICON BUTTONS (bell, tasks, fichaje)
// ────────────────────────────────────
.horizontal-layout .navbar-container .nav .nav-item {
  margin-right: 6px !important;

  .btn {
    height: 36px !important;
    padding: 0 12px !important;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-size: 12px !important;
    font-weight: 600 !important;
    border-radius: 8px !important;
    background: $h-surface !important;
    border: 1px solid $h-border !important;
    color: $h-mute !important;
    box-shadow: none !important;
    transition: all 200ms ease !important;
    display: inline-flex;
    align-items: center;
    gap: 7px;
    position: relative;

    i { font-size: 14px; }

    &:hover:not(:disabled) {
      background: rgba(59, 130, 246, 0.06) !important;
      border-color: $h-primary !important;
      color: $h-primary !important;
    }

    // Fichado activo (success)
    &.btn-success {
      background: $h-emerald !important;
      border-color: $h-emerald !important;
      color: #fff !important;

      &:hover {
        background: darken($h-emerald, 6%) !important;
        border-color: darken($h-emerald, 6%) !important;
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25) !important;
      }
    }
  }

  // Bell dropdown styling
  .dropdown-avisos > button {
    width: 36px !important;
    padding: 0 !important;
    justify-content: center;
  }

  .badge-tasks {
    position: absolute !important;
    top: -4px !important;
    right: -4px !important;
    font-family: 'JetBrains Mono', monospace;
    font-size: 9px !important;
    font-weight: 700;
    background: $h-coral !important;
    color: #fff;
    min-width: 16px;
    height: 16px;
    line-height: 16px;
    padding: 0 4px;
    border-radius: 999px;
    border: 2px solid $h-surface;
  }
}

// Dark: botones de la navbar (fichado activo mantiene su verde)
.dark-layout .horizontal-layout .navbar-container .nav .nav-item {
  .btn:not(.btn-success) {
    background: #2e2e2e !important;
    border-color: #3b3b3b !important;
    color: #d0d2d6 !important;

    &:hover:not(:disabled) {
      background: rgba(59, 130, 246, 0.15) !important;
      border-color: $h-primary !important;
      color: $h-primary-soft !important;
    }
  }

  .badge-tasks {
    border-color: #242424;
  }
}

// Dark: textos de la cabecera (logo y nombre de usuario)
.dark-layout .navbar-brand .brand-text,
.dark-layout .horizontal-layout .navbar-container .dropdown-user .dropdown-user-link .user-name {
  color: #d0d2d6 !important;
}

// ────────────────────────────────────
// 4. USER DROPDOWN (Pablo Admin + avatar)
// ────────────────────────────────────
.horizontal-layout .navbar-container .dropdown-user {
  margin-left: 6px;

  // Vuexy fija el menú a 12rem: que crezca con el texto más largo
  .dropdown-menu {
    width: auto !important;
    min-width: 12rem;
    white-space: nowrap;
  }

  .dropdown-user-link {
    display: flex !important;
    align-items: center;
    gap: 10px;
    padding: 4px 4px 4px 12px !important;
    border-radius: 10px;
    border: 1px solid $h-border;
    background: $h-surface;
    transition: all 200ms ease;

    &:hover {
      background: $h-surface-2;
      border-color: $h-soft;
    }

    .user-nav {
      flex-direction: column;
      align-items: flex-end;
      line-height: 1.1;
    }

    .user-name {
      font-family: 'Plus Jakarta Sans', sans-serif !important;
      font-size: 13px !important;
      font-weight: 700 !important;
      color: $h-ink !important;
      margin: 0 !important;
    }

    .user-status {
      font-family: 'JetBrains Mono', monospace !important;
      font-size: 9px !important;
      font-weight: 600 !important;
      color: $h-soft !important;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      margin-top: 1px;
    }

    .b-avatar {
      width: 36px !important;
      height: 36px !important;
      border-radius: 8px !important;
    }
  }
}

// ────────────────────────────────────
// 5. HORIZONTAL MENU (Marketing, Producción, Finanzas, ...)
// ────────────────────────────────────
.horizontal-layout .horizontal-menu-wrapper {
  background: $h-surface !important;
  border-bottom: 1px solid $h-border !important;
  box-shadow: 0 1px 0 $h-border !important;

  .header-navbar {
    background: $h-surface !important;
    box-shadow: none !important;
    backdrop-filter: none !important;
    border: 0 !important;
    border-bottom: 1px solid $h-border !important;
    min-height: 52px !important;
    height: 52px !important;
    border-radius: 0 !important;

    .navbar-container {
      background: transparent !important;
      padding: 0 24px !important;
      box-shadow: none !important;
      min-height: 52px !important;
      height: 52px !important;
    }
  }
}

// Top-level menu items
.horizontal-menu .horizontal-menu-wrapper .header-navbar .navbar-container ul.nav.navbar-nav > li.nav-item {
  margin: 0 3px !important;

  > a.nav-link {
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-size: 13.5px !important;
    font-weight: 600 !important;
    color: $h-mute !important;
    background: transparent !important;
    border: 1px solid transparent !important;
    border-radius: 8px !important;
    padding: 8px 14px !important;
    height: 36px;
    display: inline-flex !important;
    align-items: center !important;
    gap: 8px;
    box-shadow: none !important;
    transition: all 200ms ease !important;
    text-transform: none !important;
    letter-spacing: 0;

    i, svg { font-size: 14px; color: $h-soft; transition: color 200ms ease; }

    &:hover {
      background: $h-surface-2 !important;
      color: $h-ink !important;

      i, svg { color: $h-primary; }
    }

    &::after { display: none !important; }
  }

  // Active state
  &.active > a.nav-link,
  &.sidebar-group-active > a.nav-link {
    background: rgba(59, 130, 246, 0.10) !important;
    color: $h-primary !important;
    border-color: rgba(59, 130, 246, 0.25) !important;
    box-shadow: none !important;
    background-image: none !important;

    i, svg { color: $h-primary !important; }
  }

  // Open dropdown state
  &.show > a.nav-link {
    background: $h-surface-2 !important;
    color: $h-ink !important;
  }
}

// Submenu dropdowns
.horizontal-layout .horizontal-menu .dropdown-menu {
  background: $h-surface !important;
  border: 1px solid $h-border !important;
  border-radius: 12px !important;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12) !important;
  padding: 6px !important;
  margin-top: 6px !important;
  font-family: 'Plus Jakarta Sans', sans-serif;

  .dropdown-item {
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-size: 12.5px !important;
    font-weight: 500 !important;
    color: $h-ink !important;
    padding: 8px 12px !important;
    border-radius: 6px !important;
    transition: all 150ms ease !important;
    display: inline-flex !important;
    align-items: center;
    gap: 8px;
    width: 100%;

    i, svg { font-size: 12px; color: $h-soft; transition: color 150ms ease; }

    &:hover, &:focus {
      background: rgba(59, 130, 246, 0.08) !important;
      color: $h-primary !important;
      i, svg { color: $h-primary !important; }
    }

    &.active {
      background: rgba(59, 130, 246, 0.12) !important;
      color: $h-primary !important;
      font-weight: 600 !important;
      i, svg { color: $h-primary !important; }
    }
  }

  .dropdown-divider {
    border-top: 1px solid $h-divider !important;
    margin: 4px 0 !important;
  }

  .dropdown-header {
    font-family: 'JetBrains Mono', monospace !important;
    font-size: 9px !important;
    font-weight: 700 !important;
    color: $h-soft !important;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    padding: 8px 12px 4px !important;
  }

  .dropdown-text { font-size: 12px; color: $h-mute; padding: 8px 12px; }
}

// ────────────────────────────────────
// 6. CONTENT PADDING ADJUST
// ────────────────────────────────────
.horizontal-layout.horizontal-menu .header-navbar.navbar-horizontal.floating-nav {
  margin: 0 !important;
  border-radius: 0 !important;
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
}

// Reduce gap between menu and content
.horizontal-layout .app-content {
  padding-top: calc(64px + 52px + 12px) !important;  // top navbar + horizontal menu + small gap
}

.horizontal-layout .content-wrapper {
  padding-top: 0 !important;
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}

// Most views wrap content with margin: -2rem to break out — keep that working
// but with less excess top space
.horizontal-layout .content-area-wrapper,
.horizontal-layout .content-body {
  padding-top: 0 !important;
  margin-top: 0 !important;
}
</style>
